<template>
    <div class="result">
        <div class="inner">
            <img src="@/assets/images/clock.png" alt="">
            <h4 style="color: #0A84FF;">审核中</h4>
            <p>预计 3个工作日内完成审核，请耐心等待审核结果 <br/> 如收到驳回通知，在此页面进行信息更正。</p>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    type: Number
})
</script>

<style scoped lang="scss">
.result {
    width: 100%;
    margin-top: 50rem;
    height: 580rem;
    background-color: #fff;
    border-radius: 10rem;
    overflow: hidden;
    img{
        width: 80rem;
    }
    .inner{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    h4{
        margin: 20rem 0; font-weight: bold; font-size: 24rem;
    }
    p{
        color: #383838; margin-top: 50rem; text-align: center; line-height: 40rem;
    }
}
</style>
